export class AdminUserModel {
  static ROLES = {
    ROLE_ADMINISTRATOR: {
      CODE: 'ROLE_ADMINISTRATOR',
      DESC: 'Usuário',
    },
    ROLE_SUPER_ADMIN: {
      CODE: 'ROLE_SUPER_ADMIN',
      DESC: 'Administrador',
    },
    // ROLE_EVENT: {
    //   CODE: 'ROLE_EVENT',
    //   DESC: 'Eventos',
    // },
    // ROLE_ADMIN_EVENT: {
    //   CODE: 'ROLE_ADMIN_EVENT',
    //   DESC: 'Eventos Administrador',
    // },
  };

  id: any;
  name: string;
  email: string;
  password: string;
  retypedPassword: string;
  newPassword: string;
  newRetypedPassword: string;
  oldPassword: string;
  roles: any[];
  enabled: boolean;
  avatar: any;
}
